import { Injectable } from '@angular/core';
import { IMetricFilterWrapper } from 'app/hub-components/interfaces/query-filter.interface';
import { MetricFilterSource } from 'app/hub-components/models/metric-filter-source.model';
import { MetricFilter } from 'app/hub-components/models/metric-filter.model';
import { QueryFilterOption } from 'app/hub-components/models/query-option.model';
import { QueryService } from '../query/query.service';
import { TrackingService } from '../tracking/tracking.service';

@Injectable()
export class FilterService {
  constructor(private trackingService: TrackingService, private queryService: QueryService) {}

  public changeFilterSource(filtersArray: IMetricFilterWrapper[], filterSource: MetricFilterSource, indexAnd: number, indexOr: number, resetValues: boolean = false): void {
    if (resetValues) {
      filtersArray[indexAnd].expressions[indexOr].value = null;
    }
    filtersArray[indexAnd].expressions[indexOr].key = filterSource.key;
    filtersArray[indexAnd].expressions[indexOr]['metric'] = filterSource.metric;
  }

  public changeFilterType(filtersArray: IMetricFilterWrapper[], metricFilterSelection: string[][], filterType: QueryFilterOption, indexAnd: number, indexOr: number, resetValues?: boolean) {
    filtersArray[indexAnd].expressions[indexOr].type = filterType.type;
    metricFilterSelection[indexAnd][indexOr] = filterType.type;
    if (resetValues) {
      filtersArray[indexAnd].expressions[indexOr].value = null;
    }
  }

  public addFilter(filtersArray: IMetricFilterWrapper[], metricFilterSelection: string[][], defaultFilter: MetricFilter, filterOptions: QueryFilterOption[], indexAnd: number, indexOr: number): void {
    this.trackingService.track('Add OR block to metric filter');
    filtersArray[indexAnd].expressions.push(defaultFilter);
    metricFilterSelection[indexAnd][indexOr + 1] = filterOptions[0].type;
  }

  public addBlock(filtersArray: IMetricFilterWrapper[], metricFilterSelection: string[][], defaultFilter: MetricFilter, filterOptions: QueryFilterOption[]) {
    this.trackingService.track('Add AND block to metric filter');
    const newIndex = filtersArray.length;
    filtersArray.push({ expressions: [defaultFilter] });
    metricFilterSelection[newIndex].push(filterOptions[0].type);
  }

  public removeFilter(filtersArray: IMetricFilterWrapper[], metricFilterSelection: string[][], emptyFiltersWarning: boolean[][], indexAnd: number, indexOr: number): void {
    if (filtersArray[indexAnd].expressions.length === 1) {
      this.trackingService.track('Remove AND block from metric filter');
      filtersArray.splice(indexAnd, 1);
      metricFilterSelection.splice(indexAnd, 1);
      emptyFiltersWarning.splice(indexAnd, 1);
    } else {
      this.trackingService.track('Remove OR block from metric filter');
      filtersArray[indexAnd].expressions.splice(indexOr, 1);
      metricFilterSelection[indexAnd].splice(indexOr, 1);
      emptyFiltersWarning[indexAnd].splice(indexOr, 1);
    }
  }

  public findFilterSource(filter: MetricFilter, filterSourceList: MetricFilterSource[]) {
    return this.queryService.findMetricFilterSource(filter, filterSourceList);
  }

  public findMetricFilterOption(filterOptions: QueryFilterOption[], filter: string) {
    return filterOptions.find(option => option.type === filter);
  }
}
